import {
  CommonModule,
  DatePipe,
} from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

import { LightboxModule } from 'ngx-lightbox';
import { NgxMaskModule } from 'ngx-mask';

import {
  NgbCollapseModule,
  NgbModalModule,
} from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../auth/auth.service';
import { LoginGuard } from '../auth/loginGuard';
import { CoreModule } from '../core/core.module';
import { UserService } from '../core/services/v2/user.service';
import { MaterialModule } from '../material/material-module';
import { PhysicianService } from '../physician/physician.service';
import { SharedModule } from '../shared/shared.module';
import {
  LayoutHeaderComponent,
} from './patient-layout/layout-header/layout-header.component';
import {
  LayoutSidebarComponent,
} from './patient-layout/layout-sidebar/layout-sidebar.component';
import {
  PatientLayoutComponent,
} from './patient-layout/patient-layout.component';
import { PatientProfileModule } from './patient-profile/patient-profile.module';
import {
  PatientPhotoEditComponent,
} from './patient-profile/profile-edit/patient-photo-edit/patient-photo-edit.component';
import { PatientRoutingModule } from './patient-routing.module';
import { PatientHealthComponent } from './patient-health/patient-health.component';
import { PatientFavoritesComponent } from './patient-favorites/patient-favorites.component';
import { PatientAppointmentsComponent } from './patient-appointments/patient-appointments.component';
import { PatientFindCareComponent } from './patient-find-care/patient-find-care.component';
import { AgmCoreModule } from '@agm/core';
import { PatientSettingsComponent } from './patient-settings/patient-settings.component';
import { PatientChoosePlanComponent } from './patient-choose-plan/patient-choose-plan.component';
import { PatientActivePlanComponent } from './patient-active-plan/patient-active-plan.component';
import { PatientCheckoutComponent } from './patient-checkout/patient-checkout.component';
import { PatientFamilyDetailsComponent } from './patient-family-details/patient-family-details.component';
import { PatientPlanDetailsComponent } from './patient-plan-details/patient-plan-details.component';
import { PatientTeldacplanComponent } from './patient-teldacplan/patient-teldacplan.component';
import { PatientTeldacFaqplanComponent } from './patient-teldac-faqplan/patient-teldac-faqplan.component';
import { PatientHealthadvocatePlanComponent } from './patient-healthadvocate-plan/patient-healthadvocate-plan.component';
import { PatientNbfitnessPlanComponent } from './patient-nbfitness-plan/patient-nbfitness-plan.component';
import { PatientHealthadvocatefaqPlanComponent } from './patient-healthadvocatefaq-plan/patient-healthadvocatefaq-plan.component';
import { PatientNbrxPlanComponent } from './patient-nbrx-plan/patient-nbrx-plan.component';
import { PatientManifestrxPlanComponent } from './patient-manifestrx-plan/patient-manifestrx-plan.component';
import { PatientLifelockessentialPlanComponent } from './patient-lifelockessential-plan/patient-lifelockessential-plan.component';
import { PatientLabtestingPlanComponent } from './patient-labtesting-plan/patient-labtesting-plan.component';
import { PatientNbdealsPlanComponent } from './patient-nbdeals-plan/patient-nbdeals-plan.component';
import { PatientNbtravelPlanComponent } from './patient-nbtravel-plan/patient-nbtravel-plan.component';
import { PatientSponsoredPlanComponent } from './patient-sponsored-plan/patient-sponsored-plan.component';
import { PatientPetrxPlanComponent } from './patient-petrx-plan/patient-petrx-plan.component';
import { PatientPaymentMethodComponent } from './patient-payment-method/patient-payment-method.component';
import { PatientPrivacyPolicyComponent } from './patient-privacy-policy/patient-privacy-policy.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    PatientRoutingModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    LightboxModule,
    CoreModule,
    SharedModule,
    NgxMaskModule.forRoot(),
    PatientProfileModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    PatientLayoutComponent,
    LayoutHeaderComponent,
    LayoutSidebarComponent,
    PatientPhotoEditComponent,
    PatientFindCareComponent,
    PatientSettingsComponent,
    // PatientPrivacyPolicyComponent,
    // PatientPaymentMethodComponent,
  
   
  
          
  ],
  providers: [
    PhysicianService,
    UserService,
    AuthService,
    LoginGuard,
    DatePipe
  ],
  entryComponents: [

  ],
  bootstrap: [PatientLayoutComponent]
})
export class PatientModule { }
